package com.appcreator.compose.conversions

import com.appcreator.blueprint.conversions.TodayConversion
import com.appcreator.blueprint.core.EnvStore
import kotlin.time.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.atStartOfDayIn
import kotlinx.datetime.toLocalDateTime
import kotlinx.serialization.json.JsonElement

class TodayConvertor(
    val conversion: TodayConversion
): Convertor {
    override fun convert(envStore: EnvStore, jsonElement: JsonElement?): String {
        val date =
            Clock.System.now()
                .toLocalDateTime(TimeZone.currentSystemDefault())
                .date
        return date.atStartOfDayIn(TimeZone.currentSystemDefault()).toString()
    }

}
